import { INFLATE as INFLATE_USER_TXNS } from './user_txns'
import { CREATE_DNW_TRANSACTION_SUCCESS } from './dnw_transaction'
import { FINISH_TXNS_SHOW_MORE } from './txns'

export default function reducer(state = { map: {} }, action) {
  switch (action.type) {
    case FINISH_TXNS_SHOW_MORE: {
      const newContributors =
        action.payload.response && action.payload.response.contributors

      return {
        ...state,
        map: {
          ...state.map,
          ...newContributors.map,
        },
      }
    }
    case INFLATE_USER_TXNS: {
      const newContributors = action.payload.list.reduce((map, txn) => {
        if (txn.contributor_id) {
          map[txn.contributor_id] = {
            full_name: txn.contributor_name,
            photo: txn.contributor_photo,
          }
        }
        return map
      }, {})
      return { ...state, map: { ...newContributors, ...state.map } }
    }
    case CREATE_DNW_TRANSACTION_SUCCESS: {
      const { id, ...rest } = action.payload.sender
      if (id) {
        return {
          ...state,
          map: {
            ...state.map,
            [id]: {
              ...rest,
            },
          },
        }
      }
      return state
    }
    default:
      return state
  }
}
